import { t } from "i18next";
import { z } from "zod";

import type { StorageProviderKind } from "@/src/api/ProjectAPI.types";

export interface StorageAccessFormValues {
  label: string;
  bucket: string;
  region: string;
  host: string;
  access_key_id: string;
  secret_access_key: string;
  is_default: boolean;
}

export function buildStorageAccessSchema(
  provider: StorageProviderKind,
  isCreate: boolean,
): z.ZodType<StorageAccessFormValues, StorageAccessFormValues> {
  return z
    .object({
      label: z
        .string()
        .min(
          1,
          t("editor-organization:storageAccess.form.errors.labelRequired"),
        ),
      bucket: z
        .string()
        .min(
          1,
          t("editor-organization:storageAccess.form.errors.bucketRequired"),
        )
        .regex(
          /^s3:\/\//,
          t("editor-organization:storageAccess.form.errors.bucketUrl"),
        ),
      region: z
        .string()
        .min(
          1,
          t("editor-organization:storageAccess.form.errors.regionRequired"),
        ),
      host: z.string(),
      access_key_id: z
        .string()
        .min(
          1,
          t("editor-organization:storageAccess.form.errors.accessKeyRequired"),
        ),
      secret_access_key: z.string(),
      is_default: z.boolean(),
    })
    .superRefine((values, ctx) => {
      if (provider === "s3_compatible" && values.host.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["host"],
          message: t(
            "editor-organization:storageAccess.form.errors.hostRequired",
          ),
        });
      }
      if (isCreate && values.secret_access_key.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["secret_access_key"],
          message: t(
            "editor-organization:storageAccess.form.errors.secretRequired",
          ),
        });
      }
    });
}
